import { createContext, useContext, useEffect, useRef, useState } from "react";

const FuelwiseContext = createContext();

const FuelwiseContextProvider = ({ children }) => {
  const [selectedFuelObj, setSelectedFuelObj] = useState(null);
  const [branding, setBranding] = useState("Wh_B");
  const [carList, setCarList] = useState([]);
  const countRef = useRef(0); // this is for car is not found or user has not serached any car so preview car icons

  useEffect(() => {
    console.log("Fuelwise mounted");
    return () => console.log("Fuelwise unmounted");
  }, []);
  return (
    <FuelwiseContext.Provider
      value={{
        selectedFuelObj,
        setSelectedFuelObj,
        branding,
        setBranding,
        carList,
        setCarList,
        countRef,
      }}
    >
      {children}
    </FuelwiseContext.Provider>
  );
};
export default FuelwiseContextProvider;

export const useFuelContext = () => {
  const context = useContext(FuelwiseContext);
  if (!context) {
    console.error(
      "fuel wise catalog must be use under FuelwiseContextProvider",
    );
  }
  return context;
};
